import React, { useEffect, useMemo, useState } from 'react';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import 'moment-timezone';
import _ from 'lodash';
import MaterialTable, { MTableBody, MTableToolbar } from 'material-table';
import {
  Card, Form, Row, Col, Button,
} from 'react-bootstrap';
import Select from 'react-select';
import { Edit } from '@material-ui/icons';

import { years, tableIcons } from '../../../helpers';
import { localization, modifyDefaultOptions } from '../../../helpers/table';

import {
  getStrategyPermissions, isAdmin, isAdminRead, isProjectCreator,
} from '../../../services/rolesSvc';

import useAPI from '../../../hooks/useAPI';
import useUserContext from '../../../hooks/useUserContext';
import { getColumns, getFooter } from '../helpers/PortfolioRegisterTableHelper';
import { getActionsModel } from '../../../pages/portfolio/PassportEdit/helpers/passportRoleStatus';

const defaultYear = 2025;
function IconEdit({ disabled }) {
  return <Edit style={{ color: !disabled ? '#ffc107' : undefined }} color={disabled ? 'disabled' : undefined} />;
}

const modifiedYears = [
  { value: null, label: 'Все периоды' },
  ...years.map((val) => ({ value: val, label: val }))];

export default function TabPortfolioRegister(props) {
  const api = useAPI();
  const userCtx = useUserContext();
  const history = useHistory();

  const { stratId } = useParams();

  const [selYear, setSelYear] = useState({ value: defaultYear, label: defaultYear });
  const handleInputChange = async (val) => {
    setSelYear(val);
    await getData(val.value); // вызов обновления данных на каждую смену фильтра по годам
  };

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [projects, setProjects] = useState([]);

  const sectionLinkPart = {
    policy: 'policies',
    goal: 'goals',
    strategy: 'strats',
    tech: 'techs',
  }[props.data?.type];

  // фильтры по руководителям и мероприятиям
  const [headFilterLookup, setHeadFilterLookup] = useState({});

  useEffect(async () => {
    await getData(selYear.value); // первичный запрос данных с фильтром по году по умолчанию
  }, []);

  const arrayToLookup = (values, valueField, titleField) => (values && values.length > 0
    ? Object.fromEntries(values.map((v) => [v[valueField], v[titleField || valueField]]))
    : {});

  const arrayToLookupSortAlph = (values, valueField, titleField) => (values && values.length > 0
    ? Object.fromEntries(
      values
        .sort((a, b) => (a.displayName === b.displayName ? 0 : a.displayName < b.displayName ? -1 : 1))
        .map((v) => [v[valueField], v[titleField || valueField]]),
    )
    : {});

  const getData = async (year) => {
    try {
      const yearQuery = year ? `year=${year}&` : '';
      const result = await api.get(`/portfolios?${yearQuery}strategyId=${props.data.id}`);
      setIsLoaded(true);
      setProjects(result);

      // фильтр из имеющихся руководителей
      setHeadFilterLookup(arrayToLookupSortAlph(result.filter((r) => r.head).map((r) => r.head), 'displayName', 'displayName'));
    } catch (error) {
      setIsLoaded(true);
      setError(error);
    }
  };

  const canCreatePortfolios = useMemo(() => isProjectCreator(userCtx, stratId), []);
  const getCanEditPortfolio = (status, originPortfolioId) => {
    const can = getActionsModel(status, userCtx, stratId, originPortfolioId);
    return can.Edit || can.EditCurrent;
  };

  if (error) {
    return (
      <div style={{ color: 'red', background: 'white' }}>
        Ошибка:
        {error.message}
      </div>
    );
  } if (!isLoaded) {
    return <section className="page projects-page"><div>Загрузка...</div></section>;
  }
  return (
    <div className="tab-subproject-register" style={{ color: 'initial' }}>
      <div style={styledContainer}>
        <div>
          <Select
            placeholder="Выберите год"
            defaultValue={[{ value: defaultYear, label: defaultYear }]}
            name="yearsSingle"
            options={modifiedYears}
            onChange={handleInputChange}
            value={selYear}
            isSearchable={false}
          />
        </div>
        {canCreatePortfolios && props.data?.type !== 'policy' && props.data?.type !== 'strategy' && (
          <div style={{ marginLeft: 16 }}>
            <NavLink to={`/${sectionLinkPart}/${props.data.id}/portfolios/new`}>
              <Button variant="primary">Добавить портфель</Button>
            </NavLink>
          </div>
        )}
        {/* { canExportPassports &&
            <div style={{marginLeft: 16}}>
              <DownloadLink variant="outline-secondary"
                url={`/info/strategies/${stratId}/export?period=${selYear ? selYear.value : null}`}
                filename={`ЦП_${props.data.num}.xlsx`}
              >
                Выгрузить ЦП
              </DownloadLink>
            </div>
          } */}
        {/* {canViewReport(projects) && <div style={{marginLeft: 16}}>
            <DownloadLink variant="outline-secondary"
                          url={`/reports/strategies/${props.data.id}/projresults/report/export?year=${selYear ? selYear.value : defaultYear}`}
                          filename={`Отчет по уник. результатам СП${props.data.id}.xlsx`}>
              Отчет по уникальным результатам
            </DownloadLink>
          </div>} */}
      </div>

      <div style={styledTable}>
        <MaterialTable
          title=""
          components={{
            Container: (props) => <div className="special-filter" {...props} />,
            Body: (props) => (
              <>
                <MTableBody {...props} />
                { getFooter(props) }
              </>
            ),
          }}
          options={modifyDefaultOptions({})}
          icons={tableIcons}
          localization={localization}
          columns={getColumns({ sectionLinkPart, headFilterLookup, stratId })}
          data={projects}
          actions={[
            (rowData) => {
              const canEdit = getCanEditPortfolio(rowData.status, rowData.originId);
              return ({
                disabled: !canEdit,
                icon: () => <IconEdit disabled={!canEdit} />,
                tooltip: 'Редактировать',
                onClick: () => history.push(`/${sectionLinkPart}/${stratId}/portfolios/${rowData.id}/edit`),
              });
            },
          ]}
        />
      </div>
    </div>
  );
}

const styledTable = {
  maxWidth: '100%',
  marginTop: 32,
};
const styledContainer = {
  display: 'flex',
  zIndex: 11,
  position: 'relative',
  top: 84,
  width: 670,
  marginTop: -90,
};
